var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',{staticClass:"hide"},[_vm._v("#"+_vm._s(_vm.item.id))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.name)+": "+_vm._s(_vm.item.deviceType.name))]),_vm._v(" "),_c('abbr',[_vm._v(_vm._s(_vm.item.solarKitIds))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-822e60b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ItemTemplate.vue
// module id = 2039
// module chunks = 1